export default __webpack_public_path__ + "static/media/logo.ab8bbb35.png";